/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.10.2015
 * Copyright: xdot GmbH 2015
 */

import datefns from 'external/datefns';
import { registerLocale, setDefaultLocale } from 'external/react-datepicker';

registerLocale('de', datefns.locale);
setDefaultLocale('de');

export const DEFAULT_DATETIME_FORMAT = 'dd.MM.yy HH:mm';
export const DEFAULT_DATETIME_FORMAT_NO_YEAR = 'dd.MM. HH:mm';
export const DEFAULT_DATE_FORMAT = 'dd.MM.yy';
export const DEFAULT_TIME_FORMAT = 'HH:mm';

export function format(v, format){
    try {
        return datefns.format(new Date(v), format);
    } catch (e) {
        return '---';
    }
}

export function formatDateTimeNoSeconds(v){
    return format(v, DEFAULT_DATETIME_FORMAT);
}

export function formatDateTimeNoYear(v){
    return datefns.format(new Date(v), DEFAULT_DATETIME_FORMAT_NO_YEAR);
}

export function formatDate(v){
    return format(v, DEFAULT_DATE_FORMAT);
}

export function formatTimeNoSeconds(v){
    return format(v, DEFAULT_TIME_FORMAT);
}



// WEBPACK FOOTER //
// ./js/utils/date-format.js